import React, { useCallback, useRef, useState } from "react";

export default function Email({ quoteDetails, email, marqueeImg }) {
	const imgRef = useRef(null);
	const [imgFallback, setImgFallback] = useState(false);

	const buildPaymentLink = useCallback(() => {
		const { quoteId, email, contactNumber, firstName, lastName, postcode } =
			quoteDetails;
		const queryString = `?quote_id=${quoteId}&billing_email=${email}&billing_first_name=${firstName}&billing_last_name=${lastName}&billing_phone=${contactNumber}&shipping_postcode=${postcode}`;
		return `https://www.partyinyourgarden.co.uk/checkouts/olq-deposit-marquee-hire-checkout/${queryString}`;
	}, [quoteDetails]);

	const onImgError = useCallback(() => {
		if (!imgFallback) {
			imgRef.current.src = `https://www.partyinyourgarden.co.uk/wp-content/plugins/quote-calculator/assets/static/images/quote-images/fallback/${quoteDetails.partyType.replace(
				/\s/g,
				"-"
			)}.jpg`;
			setImgFallback(true);
		}
	}, [imgFallback, quoteDetails.partyType]);

	return (
		<html>
			<head>
				<style
					dangerouslySetInnerHTML={{
						__html: `
						:root {
							--colour-primary: #f7921c;
							--colour-secondary: #6d049d;
							--colour-black: #000000;
							--colour-white: #f5f5f5;
							--colour-green: #25d366;
							--colour-error: #ca0d0d;
							--colour-success: #26a521;
						}
						.quote-email {
							padding: 10px;
							border-radius: 3px;
							font-family: "Ubuntu", sans-serif;
							max-width: 800px;
							margin: 0 auto;
						}
						.quote-email p:first-of-type {
							margin-top: 0;
						}
						.quote-email img {
							border-radius: 3px;
							max-height: 450px;
							max-width: 800px;
							object-fit: cover;
							width: 100%;
						}

						.quote-email__img small {
							padding: 5px;
							letter-spacing: 0.5px;
							line-height: 1.5;
						}
						.quote-details__marquee-size {
							background-color: var(--colour-white);
							border-radius: 3px;
							text-align: center;
							border: 1px solid var(--colour-black);
						}
						.quote-details__category {
							font-weight: bold;
							text-align: left;
						}
						.quote-details__category {
							margin-top: 20px;
							margin-bottom: 10px;
						}
						.quote-details__detail {
							border-bottom: 1px dashed var(--colour-black);
							font-size: 14px;
							list-style: none;
							margin-bottom: 2px;
							text-align: left;
						}
						.quote-details__detail span {
							float: right;
							font-size: 14px;
							font-weight: bold;
						}
						.quote-details__img-info {
							background-color: var(--colour-white);
							border-radius: 3px;
							font-weight: bold;
							margin-top: 20px;
							border: 1px solid var(--colour-black);
						}
						.quote-details__price {
							width: 100%;
							text-align: right;
							margin-top: 14px;
							margin-bottom: 0;
						}
						.quote-details__price small {
							font-size: 60%;
							font-weight: 300;
						}
						.quote-details__price-vat {
							font-size: 32px;
							font-weight: bold;
							margin: 5px 0;
							text-align: right;
						}
						.quote-details--left {
							padding: 0;
							text-align: center;
						}
						hr {
							border-bottom: 2px solid var(--colour-black);
							border-top: none;
							margin: 12px 0;
							width: 100%;
						}
						.quote-step__pay-btn,
						.quote-step__image-btn {
							background-color: var(--colour-primary);
							border-radius: 10px;
							border: none;
							color: var(--colour-black);
							cursor: pointer;
							display: inline-block;
							font-weight: bold;
							margin: 20px auto;
							padding: 20px 0;
							text-decoration: none;
							width: 100%;
						}
						.quote-step__pay-btn:focus,
						.quote-step__image-btn:focus,
						.quote-step__pay-btn:hover,
						.quote-step__image-btn:hover,
						.quote-step__pay-btn:active,
						.quote-step__image-btn:active {
							background-color: var(--colour-black);
							border: none;
							color: var(--colour-white);
							outline: none;
						}
						.quote-step__image-btn {
							background-color: var(--colour-green);
						}
						.email-quote__ending {
							text-align: center;
						}
					`,
					}}
				/>
				<link rel="preconnect" href="https://fonts.gstatic.com" />
				<link
					href="https://fonts.googleapis.com/css2?family=Ubuntu&display=swap"
					rel="stylesheet"
				/>
			</head>
			<body>
				<div className="quote-email">
					<p>Hey {quoteDetails.firstName}, </p>

					<div
						dangerouslySetInnerHTML={{
							__html: email.opening_description,
						}}
					></div>

					<div className="quote-email__img">
						<img
							className="quote-email__marquee-img"
							src={marqueeImg}
							ref={imgRef}
							onError={onImgError}
						></img>
						<small className="quote-email__img-description">
							{email.image_description}
						</small>
					</div>

					<hr />

					<ul className="quote-details--left">
						<p className="quote-details__marquee-size">
							<strong>{quoteDetails.marquee.size}</strong> PVC
							Marquee
						</p>

						<p className="quote-details__category">
							Standard Options
						</p>
						<li className="quote-details__detail">
							1x Carpet, Dark Grey
						</li>
						<li className="quote-details__detail">
							1x Hard Flooring System
						</li>
						<li className="quote-details__detail">
							1x White Marquee Roof Lining
						</li>

						{quoteDetails.marqueeOptions.length > 0 ? (
							<p className="quote-details__category">
								Selected Options
							</p>
						) : null}
						{quoteDetails.marqueeOptions.map((option, index) => (
							<li className="quote-details__detail" key={index}>
								{option.quantity}x {option.optionName}
								<span>£{option.value}</span>
							</li>
						))}

						<p className="quote-details__price">
							£{quoteDetails.price}
							<small> (+VAT)</small>
						</p>
						<p className="quote-details__price-vat">
							£{quoteDetails.VATPrice}
						</p>
						<a
							className="quote-step__pay-btn"
							href={buildPaymentLink()}
						>
							Pay £100 Deposit Online
						</a>
						<hr />
					</ul>

					<div className="email-quote__ending">
						<div
							dangerouslySetInnerHTML={{
								__html: email.closing_description,
							}}
						></div>
						<div
							dangerouslySetInnerHTML={{
								__html: email.upload_description,
							}}
						></div>
						<a
							className="quote-step__image-btn"
							href={email.upload_button_link}
						>
							{email.upload_button_text}
						</a>
						<img src={email.trust_image} alt="" />
						<img src={email.review_image} alt="" />
					</div>
				</div>
			</body>
		</html>
	);
}
